import { DOCUMENT } from '@angular/common';
// import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { MEM_INPUT_PATH, MEM_LAYOUT_PATH, MEM_PATH } from '.';

/**
 * @description - MemService injects Memcyco scripts into the app to enhance security and prevent phishing attacks.
 *                It dynamically injects scripts into the head and body of the index.html.
 */
@Injectable({
  providedIn: 'root'
})
export class MemService {
  #document = inject(DOCUMENT);
  // #httpClient = inject(HttpClient);

  constructor() {}

  injectMemScripts(): void {
    try {
      this.#injectMemScriptsHead();
      this.#injectMemScriptBody();
    } catch (error) {
      console.error(error);
    }
  }

  #injectMemScriptsHead(): void {
    const locMemScriptElement = this.#createLOCMemScript();
    this.#document.head.appendChild(locMemScriptElement);
    const sbMemScriptElement = this.#createDesignScriptToHead();
    this.#document.head.appendChild(sbMemScriptElement);
  }

  #injectMemScriptBody(): void {
    const { body } = this.#document;
    const script = this.#createMemBodyScript();
    body.appendChild(script);
    const layoutMemScriptElement = this.#createDesignLayoutScriptToBody();
    body.appendChild(layoutMemScriptElement);
    const inputMemScriptElement = this.#createDesignInputScriptToBody();
    body.appendChild(inputMemScriptElement);
  }

  /**
   * @description - SB means 'Safety Belt' script. Published by Memcyco. Meant to prevent XSS & Phishing attacks.
   *
   */
  #createDesignScriptToHead(): HTMLScriptElement {
    const scriptElement: HTMLScriptElement = this.#document.createElement('script');
    scriptElement.src = MEM_PATH;
    scriptElement.type = 'text/javascript';
    scriptElement.defer = true;
    return scriptElement;
  }

  #createDesignLayoutScriptToBody(): HTMLScriptElement {
    const scriptElement: HTMLScriptElement = this.#document.createElement('script');
    scriptElement.src = MEM_LAYOUT_PATH;
    scriptElement.type = 'text/javascript';
    scriptElement.defer = true;
    return scriptElement;
  }

  #createDesignInputScriptToBody(): HTMLScriptElement {
    const scriptElement: HTMLScriptElement = this.#document.createElement('script');
    scriptElement.src = MEM_INPUT_PATH;
    scriptElement.type = 'text/javascript';
    scriptElement.defer = true;
    return scriptElement;
  }

  /**
   * @description - LOC means HTML 'line of code' script.
   *                This script is hidden from the user and does not appear in the HTML code.
   *                Instead, we can see it in the network as 'gwf', which means it loaded successfully.
   */
  #createLOCMemScript(): HTMLScriptElement {
    const scriptElement = this.#document.createElement('script');
    scriptElement.src = 'https://d2lyx5ly60ksu3.cloudfront.net/cdn/ca/mutha-calonline-wrapper.js';
    scriptElement.defer = true;
    scriptElement.referrerPolicy = 'strict-origin-when-cross-origin';
    return scriptElement;
  }

  #createMemBodyScript(): HTMLImageElement {
    const imgElement = this.#document.createElement('img');
    imgElement.src = 'https://d2lyx5ly60ksu3.cloudfront.net/cdn/cd/7c2c75a75890dc239675588aea0790d4-icon.jpg';
    imgElement.style.display = 'none';
    imgElement.style.height = '0px';
    imgElement.style.width = '0px';
    imgElement.style.pointerEvents = 'unset';
    return imgElement;
  }

  // #loadMemScript(): void {
  //   this.#httpClient
  //     .get(MEM_PATH, {
  //       responseType: 'text'
  //     })
  //     .pipe(
  //       takeOnce(),
  //       tap((content) => {
  //         this.#addScriptToHead(content);
  //       })
  //     )
  //     .subscribe();
  // }
}
